<template>
    <div>
        <h3>バックリンク</h3>
        <div>
            <p>
                貸し本棚でサブドメインを取得し、作家様の本棚を一部の創作系サーチサービスへ登録することができます。
                本棚を登録する場合はアカウント情報からリンクバナーを設置してください。
                小説作品を登録する場合は、小説情報でリンクバナーを設定してください。
                これらのリンクバナーは、創作系サーチサービスから本棚へのリンク設定に使用します。
            </p>
            <h4>バックリンクとは</h4>
            <p>
                ほとんどの創作系サーチサービスでは、登録するサービスにバックリンクの設置を義務付けています。
                そうでない場合もリンクを設置することをお勧めします。
            </p>
            <p>
                貸し本棚では、自己紹介文や記事でバックリンクを作成することもできますが、バックリンク専用機能を使えば、
                トップページの目立つところに「スポンサーリンク」としてリストされます。
            </p>
            <p>
                バックリンクは創作系サーチサービス限定機能ではありません。
                ご自身が所有する別のサイト、あるいはお友達の個人サイト等へのリンクを設置しても構いません。
            </p>
            <h4>バックリンクの設置方法（対応サービス）</h4>
            <p>
                対応サービスへのバックリンク設置は非常に簡単です。
                マイページのバックリンクから、新規バックリンク追加を開き、登録先のトップページのURLを貼り付けるだけです。
                リンク先名称とバナーは自動登録されます。
            </p>
            <img src="/img/help/account/06.jpg" alt="対応サービスのバックリンク" class="img-thumbnail mb-3">
            <p>
                現在の対応サービスは以下の通りです。
                登録可のサービスは公式に認められています。
                不明なサービスは公式には認められていませんが、規約上おそらく登録可能なサービスです。
            </p>
            <table class="table table-stripe">
                <thead>
                    <tr>
                        <th>サービス名</th>
                        <th>登録可</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(s, domain) in searches" :key="domain">
                        <td>
                            <a :href="s.url" target="_blank">
                                <div class="small">{{ s.name }}</div>
                                <img :src="'/img/search/' + s.banner" :alt="s.name" class="img-thumbnail img-link">
                            </a>
                        </td>
                        <td>
                            <span v-if="s.official">可</span>
                            <span v-else>不明</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <h4>バックリンクの設置方法（未対応サイト）</h4>
            <p>
                マイページのバックリンクから、新規バックリンク追加を開き、登録先のトップページのURLとサイト名を貼り付けてください。
            </p>
            <p>
                バナーは必須ではありませんが、登録をお勧めします。
            </p>
            <p>
                バナーは200px x 40pxに強制リサイズされます。アスペクト比が同じ画像（400px x 80px等）であれば問題ありません。
                表紙画像等と異なり、8bit pngやgif画像の登録も可能です。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
import searchServices from "@/searchServices";
export default {
    data() {
        return {
            searches: searchServices
        }
    },
    created() {
        this.useHead({
            title: "バックリンク | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>